import styled, { css } from "styled-components";
import { breakpoints } from "styles/grid";

const Content = styled("div")`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0 0.75rem;
	height: 35px;

	${({ presentationTemplate }) =>
		presentationTemplate &&
		css`
			height: 35px;
		`}

	@media (max-width: ${breakpoints.phone - 1}px) {
		padding: 0.5rem 0.25rem;
		flex-wrap: wrap;
		height: unset;
	}
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Item = styled("li").attrs(({ disabled, ...props }) => ({
	role: "menuitem",
	...props,
}))`
	color: ${({ theme: { colors } }) => colors.black};

	line-height: 1.5rem;
	/* border: 1px solid transparent; */

	position: relative;
	display: flex;

	${Content} {
		flex-direction: row;
		flex: 1 0 auto;
		justify-content: center;
		align-self: center;
	}

	a {
		flex: 1;
	}

	background-color: transparent;

	${({ noHover }) =>
		noHover &&
		css`
			&:hover,
			&:focus {
				cursor: initial;
				background-color: transparent !important;
			}
		`}

	${({ isActionMenuVisible }) =>
		isActionMenuVisible &&
		css`
			border-radius: var(--dz-sys-button-border-radius);
			background-color: ${({ theme: { isDarkMode } }) =>
				isDarkMode
					? "var(--dz-ref-color-gray400)"
					: "var(--dz-ref-color-gray050)"};
		`}

	&.active {
		font-weight: bold;
		color: ${({ theme: { colors } }) => colors.primary};

		svg {
			color: ${({ theme: { colors } }) => colors.primary};
		}
	}

	a,
	a:visited {
		color: unset;
	}

	${({ disabled }) =>
		disabled &&
		css`
			background: red;
		`}
`;

Item.Content = Content;

export default Item;
